export type SecretScopeType = 'org' | 'project' | 'application' | 'agent';

/** `child_org`: the clash is in a child organization, which is never named. */
export type ExistingScopeType = SecretScopeType | 'child_org';

/** The item a refused name clashes with: maestro's `Naming` clash. */
export interface ExistingItem {
  name: string;
  scopeType: ExistingScopeType;
  /** Null when the clash is somewhere the caller may not be told about, such as a child org. */
  where: string | null;
}

const SCOPE_TYPES: readonly string[] = [
  'org',
  'project',
  'application',
  'agent',
  'child_org',
];

/**
 * Reads a clash from maestro's snake_case body (studio bridge) or pypestreamAdmin's camelCase
 * GraphQL extension; anything else is `null`, so a caller falls back to its generic message.
 */
export function toExistingItem(value: unknown): ExistingItem | null {
  if (typeof value !== 'object' || value === null) return null;
  const item = value as Record<string, unknown>;
  const scopeType = item.scopeType ?? item.scope_type;
  const where = item.where ?? null;
  if (
    typeof item.name !== 'string' ||
    typeof scopeType !== 'string' ||
    !SCOPE_TYPES.includes(scopeType) ||
    (where !== null && typeof where !== 'string')
  )
    return null;
  return { name: item.name, scopeType: scopeType as ExistingScopeType, where };
}
